<template>
  <div class="mailing-list-section">
    <div class="form__input form__input--checkbox form__input--checkbox--bold">
      <input type="checkbox"
             :id="item.id"
             v-model="labelChecked" />
      <label :for="item.id">
        <div class="title">{{ item.title }}</div>
        <span class="description"
              v-if="item.description">
          {{ item.description }}
        </span>
      </label>
    </div>

    <div class="form__input form__input--checkbox form__input--checkbox--group"
         v-if="item.children && item.children.length">
      <div class="second-level"
           v-for="secondLevelItem in (item.children || [])"
           :key="secondLevelItem.id">
        <mailing-list-check :item="secondLevelItem"
                            :checked="data.includes(secondLevelItem.mailing_list_id)"
                            @change="val => $emit('change', val)" />
        <label :for="secondLevelItem.mailing_list_id">
          <div class="title">{{ secondLevelItem.title }}
          </div>
          <span class="description"
                v-if="secondLevelItem.description">
            {{ secondLevelItem.description }}
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import mailingListCheck from './MailingListsCheck';
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  props: ['item', 'data'],
  components: { mailingListCheck },
  computed: {
    childrenIds() {
      const ids = [];
      if (this.item.children) {
        this.item.children.forEach(element => {
          ids.push(element.mailing_list_id);
        });
      }
      return ids;
    },
    labelChecked: {
      get() {
        if (this.item.mailing_list_id) {
          return this.data.includes(this.item.mailing_list_id);
        } else {
          for (const id of this.childrenIds) {
            if (this.data.includes(id)) {
              return true;
            }
          }
          return false;
        }
      },
      set(newVal) {
        this.$emit('change', {
          id: this.item.mailing_list_id,
          value: !!newVal,
        });
        for (const id of this.childrenIds) {
          this.$emit('change', { id, value: !!newVal });
        }
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MailingListSection.vue